import React from "react";
import {Badge} from "react-bootstrap";
import {formatDateModern} from "../../../../../utils/util";

const componentName = "carePathClosed";

export const CarePathClosed = ({closedDate}) => {
  return (
    <>
      <Badge id={`${componentName}-closedDate`} pill bg="secondary" className="ms-2">Closed on {formatDateModern(closedDate)}</Badge>
    </>
  );
};

export default CarePathClosed;